import React, { useState } from 'react'

import Blogcard from './Blogcard';
import Card from '@mui/material/Card';
import CardActions from '@mui/material/CardActions';
import CardContent from '@mui/material/CardContent';
import Box from '@mui/material/Box';
function Blog() {
  const Blogs = [
    {
      id: 7,
      title: "Mobile App Development: Native vs. Cross-Platform",
      category: "Articles",
      imageUrl: "https://cdn.prod.website-files.com/61962f94f13cb612b8c209e2/65678c252b506c5a7a2b2f75_Mobile%20App%20Development%20-%20Native%20vs.%20Cross-Platform.jpg",
      link: "/blog",
      date: "Nov 24, 2023",
      readTime: "5 min read",
      customStyle: { marginLeft: { xs: 'auto', md: '220px' } },
      categoryIcon: "https://cdn.prod.website-files.com/61962f94f13cb612b8c209e2/61962f94f13cb649cfc20af2_icon-3-blog-categories-dark-template.svg"
    },
    {
      id: 8,
      title: "Vue.js Development v Angular v React: The Big Three",
      category: "Articles",
      imageUrl: "https://cdn.prod.website-files.com/61962f94f13cb612b8c209e2/6567832da94045cf7a675a1e_Vue.js%20Development%20v%20Angular%20v%20React%20-%20The%20Big%20Three.jpg",
      link: "/blog",
      date: "Nov 17, 2023",
      readTime: "4 min read",
      customStyle: { marginLeft: { xs: 'auto', md: '220px' } },
      categoryIcon: "https://cdn.prod.website-files.com/61962f94f13cb612b8c209e2/61962f94f13cb649cfc20af2_icon-3-blog-categories-dark-template.svg"
    },
    {
      id: 9,
      title: "eCommerce Development: 9 Essential Needs",
      category: "Articles",
      imageUrl: "https://cdn.prod.website-files.com/61962f94f13cb612b8c209e2/65678316d4dfda55b27e2eec_eCommerce%20Development%20-%20%209%20Essential%20Needs.jpg",
      link: "/blog",
      date: "Nov 10, 2023",
      readTime: "5 min read",
      customStyle: { marginLeft: { xs: 'auto', md: '220px' } },
      categoryIcon: 'https://cdn.prod.website-files.com/61962f94f13cb612b8c209e2/61962f94f13cb649cfc20af2_icon-3-blog-categories-dark-template.svg'
    },
    {
      id: 10,
      title: "Online Store: A 10-Step Process to Create",
      category: "Guides",
      imageUrl: "https://cdn.prod.website-files.com/61962f94f13cb612b8c209e2/65679798ab60adb350982b53_Online%20Store-%20A%2010%20Step%20Process%20to%20Create.jpg",
      link: "/blog",
      date: "Nov 3, 2023",
      readTime: "9 min read",
      customStyle: { marginLeft: { xs: 'auto', md: '220px' } },
      categoryIcon: "https://cdn.prod.website-files.com/61962f94f13cb612b8c209e2/61962f94f13cb6f8d4c20af1_icon-2-blog-categories-dark-template.svg"
    },
    {
      id: 11,
      title: "Top 10 Leaders in Hospitality Tech in 2023",
      category: "Guides",
      imageUrl: "https://cdn.prod.website-files.com/61962f94f13cb612b8c209e2/654bbadf09d9b7fb0cdc00f2_Hospitality_Tech_Expert_Thumbnail.webp",
      link: "/blog",
      date: "Oct 27, 2023",
      readTime: "8 min read",
      customStyle: { marginLeft: { xs: 'auto', md: '220px' } },
      categoryIcon: "https://cdn.prod.website-files.com/61962f94f13cb612b8c209e2/61962f94f13cb6f8d4c20af1_icon-2-blog-categories-dark-template.svg"
    },
    {

      id: 12,
      title: "Node.js Development vs. PHP Development",
      category: "Articles",
      imageUrl: 'https://cdn.prod.website-files.com/61962f94f13cb612b8c209e2/61c10880646e83e05feafca0_NetAesthetics_Blog_NodeJS-Php.png',
      link: "/portfolio",
      date: "Oct 20, 2023",
      readTime: "7 min read",
      customStyle: { marginLeft: { xs: 'auto', md: '220px' } },
      categoryIcon: "https://cdn.prod.website-files.com/61962f94f13cb612b8c209e2/61962f94f13cb649cfc20af2_icon-3-blog-categories-dark-template.svg"
    }
  ];
  const MoreBlogs = [
    {
      id: 13,
      title: "Magento Integration Solutions: Migrate from V1 to V2 (Part 1)",
      category: "Guides",
      imageUrl: "https://cdn.prod.website-files.com/61962f94f13cb612b8c209e2/61c108401d38a05d78017340_NetAesthetics_Blog_Magento.png",
      link: "/blog",
      date: "Oct 25, 2020",
      readTime: "7 min read",
      customStyle: { marginLeft: { xs: 'auto', md: '220px' } },
      categoryIcon: "https://cdn.prod.website-files.com/61962f94f13cb612b8c209e2/61962f94f13cb6f8d4c20af1_icon-2-blog-categories-dark-template.svg"
    },
    {
      id: 14,
      title: "CMS Solutions: What is WordPress?",
      category: "Articles",
      imageUrl: "https://cdn.prod.website-files.com/61962f94f13cb612b8c209e2/61c1086651891758471e5f4d_NetAesthetics_Blog_Wordpress.png",
      link: "/blog",
      date: "Oct 25, 2020",
      readTime: "5 min read",
      customStyle: { marginLeft: { xs: 'auto', md: '220px' } },
      categoryIcon: "https://cdn.prod.website-files.com/61962f94f13cb612b8c209e2/61962f94f13cb649cfc20af2_icon-3-blog-categories-dark-template.svg"
    },
    {
      id: 15,
      title: "How to Start eCommerce Business from Scratch [2021]",
      category: "Guides",
      imageUrl: "https://cdn.prod.website-files.com/61962f94f13cb612b8c209e2/656783231bf4e9fb1787c1bc_How%20to%20Start%20eCommerce%20Business%20from%20Scratch.jpg",
      link: "/blog",
      date: "Oct 25, 2020",
      readTime: "7 min read",
      customStyle: { marginLeft: { xs: 'auto', md: '220px' } },
      categoryIcon: 'https://cdn.prod.website-files.com/61962f94f13cb612b8c209e2/61962f94f13cb649cfc20af2_icon-3-blog-categories-dark-template.svg'
    },
    {
      id: 16,
      title: "Magento Integration Solutions: Migrate from V1 to V2 (Part 1)",
      category: "Guides",
      imageUrl: "https://cdn.prod.website-files.com/61962f94f13cb612b8c209e2/61c108401d38a05d78017340_NetAesthetics_Blog_Magento.png",
      link: "/blog",
      date: "Oct 25, 2020",
      readTime: "11 min read",
      customStyle: { marginLeft: { xs: 'auto', md: '220px' } },
      categoryIcon: "https://cdn.prod.website-files.com/61962f94f13cb612b8c209e2/61962f94f13cb6f8d4c20af1_icon-2-blog-categories-dark-template.svg"
    },
    {
      id: 17,
      title: "Machine Learning in Action: Transforming Industry Norms",
      category: "Resources",
      imageUrl: "https://cdn.prod.website-files.com/61962f94f13cb612b8c209e2/65e88157f444a627802848c1_Mini%20thumbnail%201A.jpg",
      link: "/blog",
      date: "Oct 27, 2020",
      readTime: "3 min read",
      customStyle: { marginLeft: { xs: 'auto', md: '220px' } },
      categoryIcon: "https://cdn.prod.website-files.com/61962f94f13cb612b8c209e2/61962f94f13cb6843ac20aec_icon-1-blog-categories-dark-template.svg"
    }
  ];
  const [showBlogs, setShowBlogs] = useState(false);
  const [seemorebutton, setseemorebutton] = useState(false)
  const [showmoreblogs, setshowmoreblogs] = useState(false);
  const handleSeeMoreClick = () => {
    setseemorebutton(true);
    setShowBlogs(true);
  };
  const handleSeeMoreblogsClick = () => {
    setshowmoreblogs(true);
    setseemorebutton(false)
  }


  return (
    <>
      <div className='portfolio_section'>
        <div className='services_title_con wow animate__fadeInUp' data-wow-duration="1s">
          <h2 className='services_title'>Blog & Resources</h2>
          <p className='services_paragraph'>Welcome to our blog and resources section. Here you'll find a list of our recent blog posts, articles, and other content we've created to help you out.</p>
        </div>
        <div className='portfolio_bottom'>
          <div className='portfolioheader'>
            <div>
              <div className='portfolio_anchor_con'>

                <a className='portfolio_author_image_con wow animate__fadeInUp' data-wow-duration="1s" href="/portfolio">
                  <div className='portfolio_card_author'>
                    <div class="card-post-item-about-wrapper"><div class="card-post-item-about-content">
                      <img src="https://cdn.prod.website-files.com/61962f94f13cb64145c209c3/61962f94f13cb66281c20a45_icon-1-post-about-dark-template.svg" loading="eager" alt="" class="image card-post-item-about-icon" />
                      <div>March 25, 2024</div>
                    </div><div class="card-post-item-about-content">
                        <img src="https://cdn.prod.website-files.com/61962f94f13cb64145c209c3/61962f94f13cb67710c20a43_icon-2-post-about-dark-template.svg" loading="eager" alt="" class="image card-post-item-about-icon" />
                        <div class="w-embed">4 min read</div>
                      </div>
                    </div>

                    <h2 className='portfoliotitle'>Cloud Computing 101: What Every Business Needs to Know</h2>
                    <p className='portfolioparagraph'>Cloud: Key to business innovation & growth</p>
                    <div className='portfolio_author_container'>
                      <div className='portfolio_image_container'>
                        <img className='portfolioclientimage' src="https://cdn.prod.website-files.com/61962f94f13cb612b8c209e2/61ae3ae9bab51c5e044aae7f_NetAesthetics_Rasheid-Scarlett.png" alt="" />
                      </div>
                      <div>
                        <div className='portfolio_author_name'>Rasheid Scarlett</div>
                        <div>CEO and Founder</div>
                      </div>
                    </div>
                  </div>

                  <div className='portfolio_mainimage_container'>

                    <img className='mainimage' src="https://cdn.prod.website-files.com/61962f94f13cb612b8c209e2/6601993931f0bc117b2fbfe1_Newsletter%20thumbnail%202A%20(1).jpg" alt="" />
                  </div>
                </a>

              </div>
            </div>
          </div>
        </div>
      </div>
      <div className='divider'>
        <div></div>
      </div>
      <div className='blog_container'>
        <h2 className='services_title wow animate__fadeInUp' data-wow-duration="1s" style={{ marginBottom: '50px', marginTop: '130px' }}>
          All Blogs
        </h2>
        <Blogcard />
        <div className='blog_container'>
          <div className='seemore_con wow animate__fadeInUp' data-wow-duration="1s" style={{ display: showBlogs ? 'none' : 'block', marginBottom: '30px' }}>
            <a style={{ cursor: 'pointer' }} onClick={handleSeeMoreClick}>
              See More  Blogs <svg class="w-pagination-next-icon" height="12px" width="12px" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 12 12" transform="translate(0, 1)"><path fill="none" stroke="currentColor" fill-rule="evenodd" d="M4 2l4 4-4 4"></path></svg>
            </a>
          </div>
        </div>
      </div>
      <div className={`blog_section wow animate__fadeInUp ${showBlogs ? '' : 'd-none'}`} data-wow-duration="1s" >
        {Blogs.map(Blog => (
          <Card className='muicard' key={Blog.id}>
            <Box
              sx={{
                position: 'relative',
                height: 265,
                backgroundImage: `url(${Blog.imageUrl})`,
                backgroundPosition: 'center',
                backgroundSize: 'cover',
                backgroundRepeat: 'no-repeat',
              }}
            >
              <Box className="categorytext d-flex" sx={Blog.customStyle}>
                {Blog.categoryIcon && (
                  <img src={Blog.categoryIcon} alt={`${Blog.category} icon`} style={{ marginRight: '8px' }} />
                )}
                {Blog.category}
              </Box>
            </Box>
            <CardContent style={{ textAlign: 'left' }}>
              <a  href={`/blog/${Blog.id}`} className='typographytext' variant="body2">
                {Blog.title}
              </a>
            </CardContent>
            <CardActions sx={{
              flexDirection: 'column',
              textAlign: 'left',
              alignItems: 'flex-start',
            }}>
              {/* New content before the Read More button */}
              <div className="card-post-item-about-wrapper">
                <div className="card-post-item-about-content">
                  <img src="https://cdn.prod.website-files.com/61962f94f13cb64145c209c3/61962f94f13cb66281c20a45_icon-1-post-about-dark-template.svg" loading="lazy" alt="" className="image card-post-item-about-icon" />
                  <div>{Blog.date}</div>
                </div>
                <div className="card-post-item-about-content">
                  <img src="https://cdn.prod.website-files.com/61962f94f13cb64145c209c3/61962f94f13cb67710c20a43_icon-2-post-about-dark-template.svg" loading="lazy" alt="" className="image card-post-item-about-icon" />
                  <div className="w-embed">{Blog.readTime}</div>
                </div>
              </div>
              {/* Read More button */}
              <a href={`/blog/${Blog.id}`} className='muireadmore'>Read More <span className="arrow_icon"> ↗</span></a>
              <div className='underline_animation'></div>
            </CardActions>
          </Card>
        ))}

      </div>
      <div className='blog_container'>
        <div className='seemore_con wow animate__fadeInUp ' data-wow-duration="1s" style={{ display: seemorebutton ? 'block' : 'none', marginBottom: '30px' }}>
          <a style={{ cursor: 'pointer' }} onClick={handleSeeMoreblogsClick}>
            See More  Blogs <svg class="w-pagination-next-icon" height="12px" width="12px" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 12 12" transform="translate(0, 1)"><path fill="none" stroke="currentColor" fill-rule="evenodd" d="M4 2l4 4-4 4"></path></svg>
          </a>
        </div>
      </div>
      <div className={`blog_section wow animate__fadeInUp ${showmoreblogs ? '' : 'd-none'}`} data-wow-duration="1s" >
        {MoreBlogs.map((MoreBlog, index) => (
          <Card className='muicard' key={index}>
            <Box
              sx={{
                position: 'relative',
                height: 265,
                backgroundImage: `url(${MoreBlog.imageUrl})`,
                backgroundPosition: 'center',
                backgroundSize: 'cover',
                backgroundRepeat: 'no-repeat',
              }}
            >
              <Box className="categorytext d-flex" sx={MoreBlog.customStyle}>
                {MoreBlog.categoryIcon && (
                  <img src={MoreBlog.categoryIcon} alt={`${MoreBlog.category} icon`} style={{ marginRight: '8px' }} />
                )}
                {MoreBlog.category}
              </Box>
            </Box>
            <CardContent style={{ textAlign: 'left' }}>
              <a target='_blank' href={`/blog/${MoreBlog.id}`} className='typographytext' variant="body2">
                {MoreBlog.title}
              </a>
            </CardContent>
            <CardActions sx={{
              flexDirection: 'column',
              textAlign: 'left',
              alignItems: 'flex-start',
            }}>
              {/* New content before the Read More button */}
              <div className="card-post-item-about-wrapper">
                <div className="card-post-item-about-content">
                  <img src="https://cdn.prod.website-files.com/61962f94f13cb64145c209c3/61962f94f13cb66281c20a45_icon-1-post-about-dark-template.svg" loading="lazy" alt="" className="image card-post-item-about-icon" />
                  <div>{MoreBlog.date}</div>
                </div>
                <div className="card-post-item-about-content">
                  <img src="https://cdn.prod.website-files.com/61962f94f13cb64145c209c3/61962f94f13cb67710c20a43_icon-2-post-about-dark-template.svg" loading="lazy" alt="" className="image card-post-item-about-icon" />
                  <div className="w-embed">{MoreBlog.readTime}</div>
                </div>
              </div>
              {/* Read More button */}
              <a target='_blank' href={`/blog/${MoreBlog.id}`} className='muireadmore'>Read More <span className="arrow_icon"> ↗</span></a>
              <div className='underline_animation'></div>
            </CardActions>
          </Card>
        ))}

      </div>
    </>
  )
}

export default Blog